import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

/**
 * Custom progress bar component that works reliably in sliders
 * @param {Object} props
 * @param {number} props.value - Progress value (0-100)
 * @param {number} props.height - Height of the progress bar
 * @param {string} props.color - Color of the progress bar
 * @param {string} props.backgroundColor - Background color
 * @returns {React.Component}
 */
function CustomProgressBar({
  value = 0,
  height = 8,
  color = 'primary',
  backgroundColor = 'grey.300'
}) {
  const theme = useTheme();

  // Ensure value is between 0 and 100
  const clampedValue = Math.max(0, Math.min(100, value || 0));

  // Get color from theme if it's a theme color name
  const getColor = (colorProp) => {
    if (typeof colorProp === 'string' && theme.palette[colorProp]) {
      return theme.palette[colorProp].main;
    }
    return colorProp;
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: height,
        backgroundColor: getColor(backgroundColor),
        borderRadius: height / 2,
        overflow: 'hidden',
        position: 'relative'
      }}
    >
      <Box
        sx={{
          height: '100%',
          width: `${clampedValue}%`,
          backgroundColor: getColor(color),
          borderRadius: height / 2,
          transition: 'width 0.3s ease-in-out',
          position: 'absolute',
          left: 0,
          top: 0
        }}
      />
    </Box>
  );
}

CustomProgressBar.propTypes = {
  value: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
  backgroundColor: PropTypes.string
};

export default CustomProgressBar;
